import Header from './Header';
import Sidebar from './Sidebar';

const Layout = ({
  storeInfo,
  activeTab,
  onTabChange,
  onLogout,
  onMyPageClick,
  canInstall,
  onInstallClick,
  children
}) => {
  return (
    <div className="min-h-screen bg-gray-100">
      <Header
        storeInfo={storeInfo}
        onLogout={onLogout}
        onMyPageClick={onMyPageClick}
        canInstall={canInstall}
        onInstallClick={onInstallClick}
      />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col lg:flex-row gap-8">
          <Sidebar activeTab={activeTab} onTabChange={onTabChange} />
          
          <main className="flex-1">
            {children}
          </main>
        </div>
      </div>
    </div>
  );
};

export default Layout;